// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"518":"763a026c","7347":"763a026c"}[chunkId] + ".chunk.css";
};